"use client";
import { useState, useEffect } from "react";
import Link from "next/link";
import Image from "next/image";

import { Container } from "@dxp-feed/ui/Container";
import useInputIntent from "@/utils/hooks/context/useInputIntent";
import { BINDING_CONFIG } from "@/utils/constants";

export const Header = ({
  headerFooterData,
  bindedDomain,
}: {
  headerFooterData: any;
  bindedDomain: keyof typeof BINDING_CONFIG;
}) => {
  const [headerLogo, setHeaderLogo] = useState<string>("");
  useEffect(() => {
    if (
      headerFooterData?.data?.centralLoginHeaderFooterList?.items[0]?.src
        ?._publishUrl
    ) {
      setHeaderLogo(
        headerFooterData?.data?.centralLoginHeaderFooterList?.items[0]?.src
          ?._publishUrl,
      );
    }
  }, [headerFooterData]);

  useInputIntent();

  return (
    <header className="py-6 border-solid border-b-[1px] border-light-grey">
      <Container className="max-w-[1536px] 2md:px-12 px-6">
        <Link href={BINDING_CONFIG[bindedDomain].REDIRECT_URL || "/"}>
          <Image
            src={`${BINDING_CONFIG[bindedDomain].MERCH_IDENTIFIERS}_logo.svg`}
            width={100}
            height={48}
            alt="logo"
          />
        </Link>
      </Container>
    </header>
  );
};
